import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Table } from 'components/Page';

import REDUCER_KEY from 'reducers/reducer.keys';
import ReportInput from './Input';

const mapStateToProps = state => ({
  reports: state.api.reports.data.results
});

const Reports = ({ reports }) => {
  const data = reports.map(report => ({
    id: report.id,
    name: report.name,
    description: report.description,
    form: <ReportInput
      report={report}
      showHeader={false}
      title="Download Reports"
      inputFormItemLayout={{}}
    />
  }));
  return (
    <Table
      dataSource={data}
      reducer={{
        list: REDUCER_KEY.reports,
        item: REDUCER_KEY.report
      }}
      config={{
        title: 'Reports',
        columns: [{
          title: 'Name',
          dataIndex: 'name',
          width: '180px',
          sorter: true
        },
        {
          title: 'Description',
          dataIndex: 'description'
        }],
        sorter: {
          field: 'name',
          order: 'ascend'
        }
      }}
      rowSelectionConfig={{
        selectItemOnSingleClick: false,
        selectItemOnDoubleClick: false,
        highlightRow: true,
        multiRow: true,
        toggleRow: true
      }}
      expandedRowRender={record => record.form}
    />
  );
};

Reports.propTypes = {
  reports: PropTypes.array
};

Reports.defaultProps = {
  reports: []
};

export default connect(mapStateToProps, null)(Reports);
